/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Safe reason for a verification that could not reach a conclusion.
 */
export enum WhatsAppSolutionAssociationVerificationInconclusiveReason {
    META_REQUEST_FAILED = 'meta_request_failed',
    INVALID_RESPONSE = 'invalid_response',
    PAGINATION_CYCLE = 'pagination_cycle',
    PAGINATION_LIMIT_EXCEEDED = 'pagination_limit_exceeded',
}
